import React from 'react'
import Layout from '../src/components/layouts'
import PartnerWithTheLeader from '../src/components/pages/PartnerWithTheLeader'

export async function getServerSideProps() {
  return {
    props: {},
  }
}

const PartnerWithTheLeaderPage = () => (
  <Layout footerClassName="max-w-1400">
    <PartnerWithTheLeader />
  </Layout>
)

export default PartnerWithTheLeaderPage
